const gtagOk = () => typeof window !== "undefined" && typeof window.gtag === "function";
const fbqOk = () => typeof window !== "undefined" && typeof window.fbq === "function";

export const trackEvent = (name, params = {}) => {
  if (gtagOk()) window.gtag("event", name, params);
};

const trackMeta = (name, params = {}, custom = true) => {
  if (fbqOk()) window.fbq(custom ? "trackCustom" : "track", name, params);
};

export const trackLead = () => {
  trackEvent("generate_lead", { method: "quote_form" });
  trackMeta("Lead", { content_name: "quote_form" }, false);
};

export const trackPhoneClick = (location) => {
  trackEvent("phone_cta_click", { cta_location: location });
  trackMeta("PhoneCtaClick", { cta_location: location });
};

export const trackSectionClick = (section) =>
  trackEvent("section_click", { section });

export const trackCalculatorUse = (step, detail) => {
  trackEvent("calculator_use", { calculator_step: step, ...(detail ? { detail } : {}) });
  trackMeta("CalculatorUse", { calculator_step: step });
};

export const initClickTracking = () => {
  document.addEventListener("click", (e) => {
    const el = e.target.closest("[data-testid], a[href^='tel:']");
    if (!el) return;
    const id = el.getAttribute("data-testid") || "";
    const href = el.getAttribute("href") || "";
    if (href.startsWith("tel:")) return trackPhoneClick(id || "unknown");
    if (id.startsWith("nav-link-") || id.startsWith("mobile-nav-link-") || id.startsWith("footer-link-"))
      return trackSectionClick(id);
    if (id === "hero-quote-cta-button" || id === "sticky-quote-button" || id.startsWith("service-cta-")) {
      trackEvent("quote_cta_click", { cta_location: id });
      return trackMeta("QuoteCtaClick", { cta_location: id });
    }
    if (id === "calculator-apply-button") return trackCalculatorUse("apply");
    if (id.startsWith("calculator-term-")) return trackCalculatorUse("term_change", id);
    if (id === "calculator-amount-slider") return trackCalculatorUse("amount_change");
  });
};
